import { useState } from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { downloadProtocoloFile } from 'app/services/api/user/register';
import Loader from 'app/common/Loader';
import PageHeader from "../components/PageHeader/PageHeader";
import CtaButton from '../components/CtaButton/CtaButton';

function Education() {
  const [downloadStatus, setDownloadStatus] = useState('idle');

  const handleDownload = async () => {
    try {
      setDownloadStatus('downloading');
      const response = await downloadProtocoloFile();
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = globalThis.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Protocolo_miREP_v1.1.pdf';
      document.body.appendChild(link);
      link.click();
      link.remove();
      globalThis.URL.revokeObjectURL(url);
      setDownloadStatus('success');
      setTimeout(() => setDownloadStatus('idle'), 3000);
    } catch {
      setDownloadStatus('error');
      setTimeout(() => setDownloadStatus('idle'), 4000);
    }
  };

  return (
    <>
      <Loader visible={downloadStatus === 'downloading'} />

      <PageHeader
        eyebrow="Educación"
        title="Entiende la REP y la trazabilidad"
        subtitle="Accede a contenido claro y técnico para mejorar tu gestión ambiental."
      />

      <section className="bg-white min-h-[calc(100vh-280px)] flex items-center">
        <div className="max-w-[860px] mx-auto py-96 px-40 w-full">
          <div className="bg-white border border-[#E2E8F0] rounded-20 py-52 px-48 flex items-center gap-40 flex-wrap shadow-[0_4px_24px_rgba(26,86,219,0.08)]">

            <div className="w-80 h-80 rounded-20 bg-[#EFF6FF] border border-[#BFDBFE] flex items-center justify-center shrink-0">
              <DownloadIcon className="!text-24 text-[#1A56DB]" />
            </div>

            <div className="flex-1 min-w-[200px]">
              <p className="text-14 font-bold uppercase tracking-[0.08em] text-[#1A56DB] mb-8">
                Documento técnico
              </p>
              <h3 className="text-24 font-bold text-[#1E3A8A] mb-8 leading-[1.3]">
                Protocolo miREP
              </h3>
              <p className="text-16 text-[#94A3B8]">
                Protocolo_miREP_v1.1.pdf
              </p>
              {downloadStatus === 'success' && (
                <p className="flex items-center gap-8 text-16 mt-12 text-[#16A34A]">
                  <CheckCircleIcon fontSize="small" /> Descarga exitosa
                </p>
              )}
              {downloadStatus === 'error' && (
                <p className="flex items-center gap-8 text-16 mt-12 text-[#DC2626]">
                  <ErrorOutlineIcon fontSize="small" /> Error en la descarga. Intenta de nuevo.
                </p>
              )}
            </div>

            <CtaButton
              startIcon={<DownloadIcon />}
              onClick={handleDownload}
              disabled={downloadStatus === 'downloading'}
              sx={{
                padding: '14px 28px',
                borderRadius: '10px',
                whiteSpace: 'nowrap',
                '&.Mui-disabled': {
                  backgroundColor: '#E2E8F0',
                  color: '#94A3B8',
                  boxShadow: 'none',
                },
              }}
            >
              {downloadStatus === 'downloading' ? 'Descargando...' : 'Descargar PDF'}
            </CtaButton>

          </div>
        </div>
      </section>
    </>
  );
}

export default Education;
